"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailabilityBlockSchemaProperties = exports.AvailabilityBlockSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const base_schema_1 = require("./base-schema");
const scheduler_schema_1 = require("./scheduler-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.AvailabilityBlockSchema = base_schema_1.BaseSchema.extend({
    title: zod_1.default.string(),
    timezone: zod_1.default.string(),
    openHours: zod_1.default.array(scheduler_schema_1.OpenHoursSchema).optional(),
    readCalendars: zod_1.default.array(zod_1.default.object({ id: zod_1.default.string() }).passthrough()).optional(),
    writeCalendar: zod_1.default.object({ id: zod_1.default.string() }).passthrough(),
    // @TODO: Remove the optional flag once the database is migrated => WEB-7758
    accountId: zod_1.default.string().optional(),
    // @TODO: Some fields are stored as numbers or do not exists. In order to
    //        use the schema validation, we needed to add the fields below.
    //        We should update those fields using a migration script
    createdAt: zod_1.default.date().or(zod_1.default.number()).optional(),
    updatedAt: zod_1.default.date().or(zod_1.default.number()).optional(),
});
exports.AvailabilityBlockSchemaProperties = {
    collectionName: "availabilityBlocks",
    deleteMode: schema_properties_interface_1.DeleteMode.Hard,
};
//# sourceMappingURL=availability-block-schema.js.map